<div class="content m-30 pos-relative flex flex-col">
<div class="keno-grid-container">
  <particle-smart-grid [sourceType]="sourceType" [selectableSettings]="false"
                       (selectionChanged)="rowClicked($event)">

  </particle-smart-grid>
</div>
  <!--<particle-dynamic-grid class="transactions-overview-grid"
                         [isShowCheckboxColumn]="false"
                         [items$]="items$"
                         [fieldDefinitions$]="fieldDefinitions$"
                         [pageInfo$]="pageInfo$"
                         (pageSettingsChanged)="onPageChange($event)"
                         (rowClicked)="rowClicked($event)"
  >

  </particle-dynamic-grid>-->

</div>
